import { ItemStates } from "../enum/item-states";
import { OperationParam } from "../enum/operation-param";

export class SnippetsGroupsItem {
    id: number = 0;
    txtValue: string = '';
    isArchive: boolean = false;
    // codeEditor: string = '';
    state: ItemStates = ItemStates.Undef;
}

export class SnippetsGroupsParam extends SnippetsGroupsItem{
    operation: OperationParam = OperationParam.Undef; 
}
